<template>
	<!-- 应急保电设备 -->
	<div class="emergency">
		<custom-table :pageConfig="pageConfig" :multipleSelection="multipleSelection" :buttonGroup="buttonGroup"
			:filterValue="filterValue" :tableFilter="tableFilter" :tableConfig="tableConfig" :tableData="tableData"
			@pageChange="pageChange" @buttonClick="buttonClick" @filterChange="filterChange"
			@scopeButtonClick="scopeButtonClick"></custom-table>
		<el-dialog :title="obj.title" :visible.sync="flag" width="60%">
			<div class="dialog-content">
				<ul>
					<li>
						<span>设备图片：</span>
						<img :src="$imgUrl + obj.pictureUrl" alt="" />
					</li>
					<li>
						<span>产品标题：</span>
						{{ obj.title }}
					</li>
					<li>
						<span>价格/元：</span>
						¥{{ obj.emergencyPrice }}
					</li>
					<li>
						<span>油费单价：</span>
						¥{{ obj.oilCost }}
					</li>
					<li>
						<span>提供人姓名：</span>
						{{ obj.name }}
					</li>
					<li>
						<span>设备类型：</span>
						{{ obj.typeName }}
					</li>
					<li>
						<span>输出电压：</span>
						{{ obj.voltage }}
					</li>
					<li>
						<span>设备容量：</span>
						{{ obj.volume }}
					</li>

					<li>
						<span>设备地址：</span>
						{{ obj.provinceName }}-{{ obj.cityName }}-{{ obj.countyName }}
					</li>

					<li>
						<span>设备状态：</span>
						{{ obj.statusName }}
					</li>
					<li>
						<span>设备详细：</span>
						{{ obj.conment }}
					</li>
					<li>
						<span>设备详细图片：</span>
						<img :src="$imgUrl + obj.conmentUrl" alt="" />
					</li>
					<li>
						<span>设备报告：</span>
						¥{{ obj.deviceReported }}
					</li>
					<li>
						<span>设备报告图片：</span>
						<img :src="$imgUrl + obj.deviceReportedUrl" alt="" />
					</li>
					<!-- <li>
						<span>保电方案：</span>
						¥{{ obj.scheme }}
					</li> -->
					<li>
						<span>设备证书：</span>
						<img v-for="(item,index) in obj.deviceCertificate.split(',')" :key="index" :src="$imgUrl + item"
							alt="" style="border: 1px solid #d9d9d9;" />
					</li>
				</ul>
				<!-- <el-button type="primary" @click="flag = false">关闭</el-button> -->
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		equipmentList,
		equipmentDelete,
		equipmentDetail
	} from '../../http/factory/add-eme.js';
	export default {
		name: 'emergency',
		data() {
			return {
				pageConfig: {
					totalWord: '全部数据',
					total: 100,
					pageSize: 12,
					currentPage: 1
				},
				multipleSelection: [],
				buttonGroup: [{
					type: 'primary',
					size: 'mini',
					plain: true,
					icon: 'el-icon-plus',
					word: '添加商品',
					sign: 'new'
				}],
				filterValue: {
					keyword: ''
				},
				tableFilter: [{
					prop: 'keyword',
					type: 'el-input',
					placeholder: '请输入关键词',
					size: 'small'
				}],
				tableConfig: {
					selection: true,
					stripe: true,
					tableHeader: [{
							prop: 'title',
							label: '设备信息',
							width: 400
						},
						{
							prop: 'addTime',
							label: '上传时间',
							width: 230
						},
						{
							prop: 'price',
							label: '租赁价格',
							width: 150
						},
						{
							prop: 'status',
							label: '设备状态',
							width: 150
						}
					],
					tableEvent: [{
							icon: 'el-icon-search',
							name: '查看',
							color: 'green',
							sign: 'check'
						},
						{
							icon: 'el-icon-edit',
							name: '修改',
							color: 'blue',
							sign: 'edit'
						},
						{
							icon: 'el-icon-delete',
							name: '删除',
							color: 'red',
							sign: 'delete'
						}
					],
					emptyDescription: '当前没有数据'
				},
				tableData: [],
				flag: false,
				obj: {
					pictureUrl: '',
					title: '',
					emergencyPrice: '',
					oilCost: '',
					name: '',
					typeName: '',
					voltage: '',
					volume: '',
					provinceName: '',
					cityName: '',
					countyName: '',
					statusName: '',
					conment: '',
					conmentUrl: '',
					deviceReported: '',
					deviceReportedUrl: '',
					scheme: '',
					deviceCertificate: ''
				}
			};
		},
		methods: {
			// 页面变化
			pageChange() {
				this.fetchData();
			},
			// 右上按钮
			buttonClick(sign) {
				if (sign === 'new') {
					this.$router.push({
						path: '/factoryUser/factoryEmeAdd'
					});
				}
			},
			// 筛选条件变化
			filterChange() {
				this.fetchData()
			},
			// 操作按钮
			scopeButtonClick(row, sign) {
				if (sign === 'edit') {
					this.$router.push({
						path: '/factoryUser/factoryEmeAdd',
						query: {
							id: row.id
						}
					});
				}
				if (sign === 'delete') {
					this.deleteEqu(row);
				}
				if (sign === 'check') {
					this.checkEqu(row);
				}
			},
			// 删除设备
			deleteEqu(row) {
				this.$confirm('确认删除这个设备吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						equipmentDelete({
							serviceType: 1,
							id: row.id
						}).then(res => {
							this.$message({
								message: '删除设备成功',
								type: 'success'
							});
							this.fetchData();
						});
					})
					.catch(() => {});
			},
			getStatusWord(status) {
				let str = ''
				switch (status) {
					case 1:
						str = '故障(已报修)'
						break;
					case 2:
						str = '故障(未报修)'
						break;
					case 3:
						str = '损坏'
						break;
					default:
						str = '正常'
						break;
				}
				return str
			},
			// 获取设备列表
			fetchData() {
				equipmentList({
					serviceType: 1,
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage,
					title: this.filterValue.keyword,
				}).then(res => {
					let list = res.rows;
					let array = new Array();
					for (let i = 0; i < list.length; i++) {
						let obj = {
							title: list[i].title,
							addTime: list[i].addTime,
							price: list[i].emergencyPrice,
							id: list[i].id,
							status: this.getStatusWord(list[i].status)
						};
						array.push(obj);
					}
					this.tableData = array;
					this.pageConfig.total = res.total;
				});
			},
			// 查看设备详情
			checkEqu(row) {
				equipmentDetail({
					serviceType: 1,
					id: row.id
				}).then(res => {
					res['statusName'] = this.getStatusWord(res.status)
					this.obj = res;
					this.flag = true;
				});
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData();
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.emergency {
		width: 100%;
		height: 810px;
		background: @vue-bg-color;
	}

	.dialog-content {
		width: 100%;

		ul {
			width: 100%;

			li {
				width: 100%;
				line-height: 40px;
				display: flex;
				flex-wrap: wrap;

				img {
					width: 200px;
					margin-right: @vue-spacing-row-base;
				}

				span {
					width: 100px;
					color: @vue-text-color-grey;
				}
			}
		}
	}
</style>
